export default {
  "content": "<path d=\"M23.064 3.32h-4.5V1.85c0-.808-.674-1.47-1.5-1.47h-15c-.825 0-1.5.662-1.5 1.47v8.82c0 4.866 4.035 8.82 9 8.82 3.915 0 7.245-2.455 8.476-5.88h2.024c2.476 0 4.5-1.984 4.5-4.41V4.79c0-.808-.674-1.47-1.5-1.47zm-1.5 5.88c0 .809-.674 1.47-1.5 1.47h-1.5V6.26h3V9.2z\" fill=\"#3F4450\"/>",
  "attrs": {
    "width": "25",
    "height": "20",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};